import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { etiquetaDeJornada, jornadasDeRueda } from "./jornadas";
import { fechasConPartidosProgramados, generarPlanillaArbitros } from "./planillaArbitros";
import { toastBigError } from "components/utils/toasts";

// Pregunta de qué jornada de la rueda se generan las planillas de árbitros. Sale
// una planilla por cada zona que juega ese día, todas en el mismo PDF y cada una
// arrancando en hoja nueva.
export default function PlanillaArbitrosModal({ isOpen, round, torneoNombre, torneoAno, teams = [], onClose }) {
  const jornadas = React.useMemo(() => jornadasDeRueda(round), [round]);
  const [dia, setDia] = React.useState("");
  const [generando, setGenerando] = React.useState(false);

  // Al abrir se propone la jornada más reciente.
  React.useEffect(() => {
    if (isOpen) setDia(jornadas.length ? jornadas[0].dia : "");
  }, [isOpen, jornadas]);

  const jornada = jornadas.find((j) => j.dia === dia) || null;
  // Una zona sin partidos programados no tiene nada que arbitrar: los partidos sin
  // cancha u horario no entran en la planilla.
  const conPartidos = fechasConPartidosProgramados((jornada && jornada.fechas) || []);

  const generar = async () => {
    if (!jornada || conPartidos.length === 0) return;
    setGenerando(true);
    try {
      await generarPlanillaArbitros({
        fechas: conPartidos,
        numero: jornada.numero,
        dia: jornada.dia,
        torneoNombre,
        torneoAno,
        teams,
      });
      onClose();
    } catch (ex) {
      toastBigError("No se pudo generar la planilla", "Intentá de nuevo en un momento.");
    } finally {
      setGenerando(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>Planilla Árbitros</ModalHeader>
      <ModalBody>
        {jornadas.length === 0 ? (
          <p className="text-muted mb-0" style={{ fontSize: "0.875rem" }}>
            Las zonas de esta rueda todavía no tienen fechas con día asignado.
          </p>
        ) : (
          <React.Fragment>
            <div className="form-group">
              <label className="font-weight-bold" style={{ fontSize: "0.8125rem" }}>
                Fecha
              </label>
              <select className="form-control" value={dia} onChange={(e) => setDia(e.target.value)}>
                {jornadas.map((j) => (
                  <option key={j.dia} value={j.dia}>
                    {etiquetaDeJornada(j)}
                  </option>
                ))}
              </select>
            </div>

            <p className="text-muted mb-0" style={{ fontSize: "0.8125rem" }}>
              {conPartidos.length === 0
                ? "Esa fecha todavía no tiene partidos con cancha y horario asignados."
                : "Sale una planilla por zona: " + conPartidos.map((f) => f.zone.name).join(", ") + "."}
            </p>
          </React.Fragment>
        )}
      </ModalBody>
      <ModalFooter>
        <Button className="btn-arhock btn-sm my-0" style={{ opacity: 0.55 }} onClick={onClose}>
          Cancelar
        </Button>
        <Button
          className="btn-arhock btn-sm my-0"
          onClick={generar}
          disabled={conPartidos.length === 0 || generando}
        >
          {generando ? "Generando..." : "Generar"}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
